/**
 * Raw spend expressed with the user's margin: spend / (1 - margin).
 * A missing or non-numeric margin counts as 0, and a margin outside
 * [0, 1) leaves the spend as is, so the result is never Infinity or NaN.
 * @param {number|string} value  - Raw spend.
 * @param {number|string} margin - User margin (session.user.rtb_margin).
 * @returns {number}
 */
export const applyMarginToSpend = (value, margin) => {
    const spend = Number(value);
    if (!Number.isFinite(spend)) return 0;

    const rate = Number(margin);
    if (!Number.isFinite(rate) || rate < 0 || rate >= 1) return spend;

    return spend / (1 - rate);
};
